.clipboardContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}

.iconContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}
